import GatewayService from '../GatewayService.js';
var storage = new GatewayService('iau-service');

var fetchBinary = function fetchBinary(userKey, fileName) {
  return storage.get("iau/".concat(userKey, "/").concat(fileName), {
    headers: {
      'Content-Type': 'application/octet-stream'
    }
  });
};

var writeBinary = function writeBinary(userKey, fileName, data) {
  return storage.put("iau/".concat(userKey, "/").concat(fileName), data, {
    headers: {
      'Content-Type': 'application/octet-stream'
    }
  });
};

export default {
  fetchBinary: fetchBinary,
  writeBinary: writeBinary
};